var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2646",
    d: "M21-682.665H0v21H21Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38206",
    "data-name": "Group 38206",
    transform: "translate(2570 -3527)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14721",
    "data-name": "Rectangle 14721",
    width: 24,
    height: 24,
    transform: "translate(-2570 3527)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "exit",
    transform: "translate(-2568.5 3528.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2644",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2650",
    transform: "translate(7.014 0.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2652",
    d: "M-428-480.741v1.641a2.461,2.461,0,0,0,2.461,2.461h8.244a2.461,2.461,0,0,0,2.461-2.461v-14.437A2.461,2.461,0,0,0-417.294-496h-8.244A2.461,2.461,0,0,0-428-493.538v1.641",
    transform: "translate(427.999 495.999)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2654",
    transform: "translate(1.025 10.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2656",
    d: "M-361.332,0h11.115",
    transform: "translate(361.332)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2658",
    transform: "translate(0.82 7.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2660",
    d: "M2.2-170.585.36-172.422a1.23,1.23,0,0,1,0-1.74L2.2-176",
    transform: "translate(0 176)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.197a6a00a4272eef3880c663bbd0d2ce.svg";
export { ForwardRef as ReactComponent };